import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import {
  DoconModal,
  DoconModalContent,
  DoconModalHeader,
} from '@docon/docon-ui-library';
import { bgColor, colors } from 'utilities/colorConfig';

const StyledModal = styled(DoconModal)`
  width: 95%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: default;
  transition: all 0.3s ease-in;
  max-height: ${({ $maxHeight }: any) => $maxHeight};
  max-width: ${({ $maxWidth }: any) => $maxWidth};
  --closeIconColor: ${colors.white};
  --paddingLeftRight: 16px;

  ${DoconModalContent} {
    max-height: initial;
    padding: 0;
    overflow: overlay;
    background-color: ${bgColor.base};
  }

  ${DoconModalHeader} {
    min-height: 56px;
    font-size: 20px;
    line-height: 24px;
    padding: 10px var(--paddingLeftRight);
    color: ${colors.white};
    background-color: ${colors.primaryBlue};
    border: 0;

    svg { cursor: pointer; }
  }

  ${() => isMobileOnly && css`
    /* ${DoconModalContent} {
      padding: 0.5rem;
    } */
  `}
`;

export { StyledModal };